import React from "react";
import SEO from "@/components/SEO";
import LocationTemplate from "@/components/LocationTemplate";

const suburbName = "Heidelberg West";
const suburbSlug = "heidelberg-west";

const HeidelbergWestPage = () => (
  <>
    <LocationTemplate suburbName={suburbName} suburbSlug={suburbSlug} />
    <SEO
      title={`Dentist ${suburbName} | Y3 Smiles Dental — Family & Emergency`}
      description={`Family dentist near ${suburbName}. CDBS for kids, all health funds, same-day emergency. In nearby Broadmeadows. Book online.`}
      canonicalUrl={`https://y3smilesdental.com.au/locations/${suburbSlug}/`}
      image="/og-shopfront.jpg"
    >
      <meta name="robots" content="noindex, follow" />
    </SEO>
  </>
);

export default HeidelbergWestPage;
